import { createModule } from '../../actions/utils';
import { SERVICE_ENDPOINT } from '../../apis/constants';

const GetExpenseWorkflows = createModule(
  { base: 'GET_EXPENSE_WORKFLOWS', apiDetails: SERVICE_ENDPOINT.WORKFLOWS },
);

const UpdateExpenseStatus = createModule({
  base: 'UPDATE_EXPENSE_STATUS',
  apiDetails: { url: `${SERVICE_ENDPOINT.EXPENSE.url}/status`, method: 'put' },
  enableNotification: true,
  customNotificationSuccessMessage: 'Expense status updated successfully',
});

const UpdateExpenseWorkflowStep = createModule({
  base: 'UPDATE_EXPENSE_WORKFLOW_STEP',
  apiDetails: { url: `${SERVICE_ENDPOINT.EXPENSE.url}/workflow`, method: 'post' },
});

export { GetExpenseWorkflows, UpdateExpenseStatus, UpdateExpenseWorkflowStep };
